import React from "react";
import { Box } from "@mui/material";

import PageHeader from "../../../components/PageHeader";
import IntegrationPage from "../../../components/organisms/IntegrationPage";
import useOrganizationSubscription from "../../../hooks/useOrganizationSubscription";

/**
 * API keys and integration settings (moved out of Admin for a cleaner org-settings flow).
 */
const DevelopersPage = () => {
  const uid = localStorage.getItem("uid");
  const { organizationData: subscribeOrg } = useOrganizationSubscription({ uid });

  return (
    <>
      <PageHeader
        title="Developers"
        subtitle="API keys and third-party integration"
      />
      <Box sx={{ px: 3, pb: 3 }}>
        <Box
          sx={{
            maxWidth: 960,
            backgroundColor: "white",
            p: 3,
            borderRadius: 1,
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <IntegrationPage organizationData={subscribeOrg} />
        </Box>
      </Box>
    </>
  );
};

export default DevelopersPage;
